import { Link, useNavigate } from "react-router-dom";
import { Play, FileDown } from "lucide-react";
import { ACTS, PERSONAS, writeDemo } from "@/features/demo/tour";

export default function Demo() {
  const navigate = useNavigate();
  const start = (i = 0) => {
    writeDemo({ act: i, startedAt: Date.now() });
    navigate(ACTS[i].route);
  };
  const total = ACTS.reduce((a, b) => a + b.minutes, 0);

  return (
    <main className="mx-auto max-w-4xl px-4 py-12 sm:py-16">
      <p className="text-sm font-medium uppercase tracking-widest text-primary">Presenter mode</p>
      <h1 className="mt-2 font-heading text-4xl font-bold sm:text-5xl">Show WeKIT in {total} minutes</h1>
      <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
        Five short acts. A bar at the bottom follows you from page to page with talking points, a timer and next/back.
      </p>
      <div className="mt-8 flex flex-wrap gap-3">
        <button onClick={() => start(0)} className="inline-flex min-h-12 items-center gap-2 rounded-full bg-primary px-6 font-semibold text-primary-foreground">
          <Play className="h-5 w-5" aria-hidden /> Start the tour
        </button>
        <Link to="/pitch-deck" className="inline-flex min-h-12 items-center gap-2 rounded-full border border-border px-6 font-semibold hover:bg-muted">
          <FileDown className="h-5 w-5" aria-hidden /> Pitch deck
        </Link>
      </div>

      <h2 className="mt-14 font-heading text-2xl font-semibold">Pick who you're showing</h2>
      <p className="mt-2 text-muted-foreground">Sign in with a demo account that fits the story, then start the tour.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {PERSONAS.map((p) => (
          <article key={p.id} className="rounded-3xl border border-border bg-card p-6">
            <p className="text-sm text-muted-foreground">Age {p.age}</p>
            <h3 className="mt-1 text-xl font-semibold">{p.name}</h3>
            <p className="mt-2">{p.story}</p>
            <p className="mt-3 text-sm text-muted-foreground">{p.highlight}</p>
          </article>
        ))}
      </div>

      <h2 className="mt-14 font-heading text-2xl font-semibold">The five acts</h2>
      <ol className="mt-6 space-y-4">
        {ACTS.map((a, i) => (
          <li key={a.n} className="rounded-3xl border border-border bg-card p-6">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="text-sm text-muted-foreground">Act {a.n} · {a.minutes} min</p>
                <h3 className="text-xl font-semibold">{a.title}</h3>
              </div>
              <button onClick={() => start(i)} className="min-h-11 rounded-full border border-border px-5 text-sm font-medium hover:bg-muted">
                Start here
              </button>
            </div>
            <ul className="mt-3 space-y-1 text-muted-foreground">
              {a.say.map((s) => <li key={s}>• {s}</li>)}
            </ul>
          </li>
        ))}
      </ol>
    </main>
  );
}
